import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Router
import {Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { ButtonToolbar, Dropdown, MenuItem } from 'react-bootstrap';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-bootstrap-date-picker';

class StaffsEditTab extends Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.staff_id,
      name: this.props.staff_data.name,
      phone: this.props.staff_data.phone,
      celular_1: this.props.staff_data.celular_1,
      celular_2: this.props.staff_data.celular_2,
      email: this.props.staff_data.email,
      cpf: this.props.staff_data.cpf_str,
      identity: this.props.staff_data.identity,
      moodle_id: this.props.staff_data.moodle_id,
      sigtrip_id: this.props.staff_data.sigtrip_id,
      sigmec_id: this.props.staff_data.sigmec_id,
      sigtrip_staffs: [],
      sigmec_staffs: [],
      id_uf: this.props.staff_data.id_uf,
      id_date: this.props.staff_data.id_date_str,
      id_org: this.props.staff_data.id_org,
      inscription: this.props.staff_data.inscription,
      date_of_birth: this.props.staff_data.date_of_birth,
      date_of_birth_str: this.props.staff_data.date_of_birth_str,
      uf_birth: this.props.staff_data.uf_birth,
      canac: this.props.staff_data.canac,
      agency: this.props.staff_data.agency,
      bank: this.props.staff_data.bank,
      account: this.props.staff_data.account,
      pis: this.props.staff_data.pis,
      instrutor: this.props.staff_data.instrutor,
      instrutor_txt: this.props.staff_data.instrutor_txt,
      classe_instrutor: null,
      troca: '',
      skip_tutor_payment: Boolean(this.props.staff_data.skip_tutor_payment),
    };

    //bind específico
    this.editar = this.editar.bind(this);
    this.trocar_instrucao = this.trocar_instrucao.bind(this);
    this.handleChangeIdDatePicker = this.handleChangeIdDatePicker.bind(this);
    this.handleChangeDateOfBirthPicker = this.handleChangeDateOfBirthPicker.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.loadExternalStaffs = this.loadExternalStaffs.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeDateOfBirthPicker(value, formattedValue) {
    this.setState({
      date_of_birth: value,
      date_of_birth_str: formattedValue,
    });
  }
  handleChangeIdDatePicker(value, formattedValue) {
    this.setState({
      id_date: value,
      id_date_str: formattedValue,
    });
  }

  handleCheckboxChange(name, event) {
    var change = {};
    change[name] = event.target.checked;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentDidMount() {
    this.loadExternalStaffs();
  }

  loadExternalStaffs() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      Promise.all([
        fetch(config.get('api') + '/sigtrip/colaboradores/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()),
        fetch(config.get('api') + '/sigmec/colaboradores/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()),
      ]).then(function(responses) {
        if (responses[0] && responses[0].status === 'success') {
          self.setState({sigtrip_staffs: responses[0].data});
        }
        if (responses[1] && responses[1].status === 'success') {
          self.setState({sigmec_staffs: responses[1].data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.staff_id,
        name: newProps.staff_data.name,
        phone: newProps.staff_data.phone,
        celular_1: newProps.staff_data.celular_1,
        celular_2: newProps.staff_data.celular_2,
        email: newProps.staff_data.email,
        cpf: newProps.staff_data.cpf_str,
        identity: newProps.staff_data.identity,
        moodle_id: newProps.staff_data.moodle_id,
        sigtrip_id: newProps.staff_data.sigtrip_id,
        sigmec_id: newProps.staff_data.sigmec_id,
        id_uf: newProps.staff_data.id_uf,
        id_date: newProps.staff_data.id_date_str,
        date_of_birth: newProps.staff_data.date_of_birth,
        date_of_birth_str: newProps.staff_data.date_of_birth_str,
        id_org: newProps.staff_data.id_org,
        inscription: newProps.staff_data.inscription,
        uf_birth: newProps.staff_data.uf_birth,
        canac: newProps.staff_data.canac,
        agency: newProps.staff_data.agency,
        bank: newProps.staff_data.bank,
        account: newProps.staff_data.account,
        pis: newProps.staff_data.pis,
        instrutor: newProps.staff_data.instrutor,
        instrutor_txt: newProps.staff_data.instrutor_txt,
        classe_instrutor: newProps.staff_data.classe_instrutor,
        troca: newProps.staff_data.troca,
        troca_index: newProps.staff_data.troca_index,
        sigtrip_id: newProps.staff_data.sigtrip_id,
        sigmec_id: newProps.staff_data.sigmec_id,
        skip_tutor_payment: Boolean(newProps.staff_data.skip_tutor_payment),
      });
    }
  }

  // Editar e gerar alerta
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      phone: this.state.phone,
      celular_1: this.state.celular_1,
      celular_2: this.state.celular_2,
      email: this.state.email,
      date_of_birth: this.state.date_of_birth_str,
      cpf: this.state.cpf,
      identity: this.state.identity,
      id_uf: this.state.id_uf,
      id_date: this.state.id_date_str,
      id_org: this.state.id_org,
      inscription: this.state.inscription,
      uf_birth: this.state.uf_birth,
      canac: this.state.canac,
      agency: this.state.agency,
      bank: this.state.bank,
      account: this.state.account,
      pis: this.state.pis,
      moodle_id: this.state.moodle_id,
      sigtrip_id: this.state.sigtrip_id,
      sigmec_id: this.state.sigmec_id,
      skip_tutor_payment: this.state.skip_tutor_payment ? 1 : 0,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alunos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Trocar instrução e gerar alerta
  trocar_instrucao(eventKey) {
    var troca = eventKey
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      instrutor: troca,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aluno/trocar_instrucao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({instrutor: troca});
          if(troca == 1) {
            self.setState({instrutor_txt: 'Instrutor', troca_index: 0, classe_instrutor: 'success',  troca: 'Retirar status de instrução'});
          } else {
            self.setState({instrutor_txt: 'Não instrutor', troca_index: 1, classe_instrutor: 'warning',  troca: 'Trocar para instrutor'});
          }
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Cadastro do aluno</h3>
  <hr/>
  <h4>Informações pessoais</h4>
  <form onSubmit={this.editar}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome:</label>
          <input type="text" name="name" className="form-control" placeholder="Seu nome" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>E-mail:</label>
          <input type="text" name="email" className="form-control" placeholder="E-mail do aluno/instrutor" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nascimento:</label>
          <DatePicker onChange={this.handleChangeDateOfBirthPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de Nascimento" value={self.state.date_of_birth} />
        </div>
      </div>

      <div className="col-md-6">
        <div className="form-group">
          <label>UF nascimento:</label>
          <Select
            className="form-field-name"
            name="uf_birth"
            value={this.state.uf_birth}
            searchable={true}
            placeholder={'UF de Nascimento'}
            onChange={this.handleSelectChange.bind(this, 'uf_birth')}
            options={[
              {value: "AC", label: "Acre"},
              {value: "AL", label: "Alagoas"},
              {value: "AM", label: "Amazonas"},
              {value: "AP", label: "Amapá"},
              {value: "BA", label: "Bahia"},
              {value: "CE", label: "Ceará"},
              {value: "DF", label: "Distrito Federal"},
              {value: "ES", label: "Espírito Santo"},
              {value: "GO", label: "Goiás"},
              {value: "MA", label: "Maranhão"},
              {value: "MT", label: "Mato Grosso"},
              {value: "MS", label: "Mato Grosso do Sul"},
              {value: "MG", label: "Minas Gerais"},
              {value: "PA", label: "Pará"},
              {value: "PB", label: "Paraíba"},
              {value: "PR", label: "Paraná"},
              {value: "PE", label: "Pernambucano"},
              {value: "PI", label: "Piauí"},
              {value: "RJ", label: "Rio de Janeiro"},
              {value: "RN", label: "Rio Grande do Norte"},
              {value: "RO", label: "Rondônia"},
              {value: "RS", label: "Rio Grande do Sul"},
              {value: "RR", label: "Roraima"},
              {value: "SC", label: "Santa Catarina"},
              {value: "SE", label: "Sergipe"},
              {value: "SP", label: "São Paulo"},
              {value: "TO", label: "Tocantins"},
            ]}
          />    
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Telefone:</label>
          <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do aluno/instrutor" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Celular 1:</label>
          <InputMask value={this.state.celular_1}  maskChar={null} name="celular_1" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'celular_1')} placeholder="Celular 1 do aluno/instrutor" />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Celular 2:</label>
          <InputMask value={this.state.celular_2}  maskChar={null} name="celular_2" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'celular_2')} placeholder="Celular 2 do aluno/instrutor" />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={this.state.skip_tutor_payment}
              onChange={this.handleCheckboxChange.bind(this, 'skip_tutor_payment')}
            />
            {' '}Não gerar pagamento de tutor automaticamente
          </label>
          <small className="help-block">
            Marque para que este colaborador seja ignorado pelo processamento automático de pagamentos de tutor.
          </small>
        </div>
      </div>
    </div>
    <hr />
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>CPF:</label>
          <InputMask value={this.state.cpf}  maskChar={null} name="cpf" mask="999.999.999-99" className="form-control" onChange={this.handleChange.bind(this, 'cpf')} placeholder="CPF do aluno/instrutor" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Identidade:</label>
          <input type="text" name="identity" className="form-control" placeholder="Identidade do aluno/instrutor" value={this.state.identity} onChange={this.handleChange.bind(this, 'identity')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>ID UF:</label>
          <Select
            className="form-field-name"
            name="id_uf"
            value={this.state.id_uf}
            searchable={true}
            placeholder={'UF da identidade do aluno/instrutor'}
            onChange={this.handleSelectChange.bind(this, 'id_uf')}
            options={[
              {value: "AC", label: "Acre"},
              {value: "AL", label: "Alagoas"},
              {value: "AM", label: "Amazonas"},
              {value: "AP", label: "Amapá"},
              {value: "BA", label: "Bahia"},
              {value: "CE", label: "Ceará"},
              {value: "DF", label: "Distrito Federal"},
              {value: "ES", label: "Espírito Santo"},
              {value: "GO", label: "Goiás"},
              {value: "MA", label: "Maranhão"},
              {value: "MT", label: "Mato Grosso"},
              {value: "MS", label: "Mato Grosso do Sul"},
              {value: "MG", label: "Minas Gerais"},
              {value: "PA", label: "Pará"},
              {value: "PB", label: "Paraíba"},
              {value: "PR", label: "Paraná"},
              {value: "PE", label: "Pernambucano"},
              {value: "PI", label: "Piauí"},
              {value: "RJ", label: "Rio de Janeiro"},
              {value: "RN", label: "Rio Grande do Norte"},
              {value: "RO", label: "Rondônia"},
              {value: "RS", label: "Rio Grande do Sul"},
              {value: "RR", label: "Roraima"},
              {value: "SC", label: "Santa Catarina"},
              {value: "SE", label: "Sergipe"},
              {value: "SP", label: "São Paulo"},
              {value: "TO", label: "Tocantins"},
            ]}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>ID expedição:</label>
          <DatePicker onChange={this.handleChangeIdDatePicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Expedição da identidade do Aluno/Instrutor" value={this.state.id_date} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>ID orgão de expedição:</label>
          <input value={this.state.id_org} name="id_org" className="form-control" onChange={this.handleChange.bind(this, 'id_org')} placeholder="Orgão expeditor da identidade do aluno/instrutor" />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Agência bancária:</label>
          <input type="text" name="agency" className="form-control" placeholder="Agência" value={this.state.agency} onChange={this.handleChange.bind(this, 'agency')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>PIS:</label>
          <input type="text" name="pis" className="form-control" placeholder="PIS" value={this.state.pis} onChange={this.handleChange.bind(this, 'pis')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>C/C:</label>
          <input type="text" name="account" className="form-control" placeholder="Conta corrente" value={this.state.account} onChange={this.handleChange.bind(this, 'account')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Banco:</label>
          <input type="text" name="bank" className="form-control" placeholder="Banco" value={this.state.bank} onChange={this.handleChange.bind(this, 'bank')} />
        </div>
      </div>
    </div>
    <hr />
    <h4>Informações profissionais</h4>
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label>CANAC:</label>
              <InputMask value={this.state.canac}  maskChar={null} name="canac" mask="999999" className="form-control" onChange={this.handleChange.bind(this, 'canac')} placeholder="CANAC do Aluno/Instrutor" />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>Matrícula:</label>
          <input type="text" name="inscription" className="form-control" placeholder="Matrícula do aluno/instrutor" value={this.state.inscription} onChange={this.handleChange.bind(this, 'inscription')} />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label>Moodle ID:</label>
          <input type="text" name="moodle_id" className="form-control" placeholder="Id no moodle" value={this.state.moodle_id} onChange={this.handleChange.bind(this, 'moodle_id')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Colaborador SIGTRIP:</label>
          <Select
            className="form-field-name"
            name="sigtrip_id"
            value={this.state.sigtrip_id}
            searchable={true}
            clearable={true}
            placeholder={'Selecionar colaborador SIGTRIP pelo ID'}
            onChange={this.handleSelectChange.bind(this, 'sigtrip_id')}
            options={this.state.sigtrip_staffs}
            noResultsText={'Nenhum colaborador localizado'}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Colaborador SIGMEC:</label>
          <Select
            className="form-field-name"
            name="sigmec_id"
            value={this.state.sigmec_id}
            searchable={true}
            clearable={true}
            placeholder={'Selecionar colaborador SIGMEC pelo ID'}
            onChange={this.handleSelectChange.bind(this, 'sigmec_id')}
            options={this.state.sigmec_staffs}
            noResultsText={'Nenhum colaborador localizado'}
          />
        </div>
      </div>
    </div>
    <hr/>
    <ButtonToolbar>
      <button type={'submit'} className="btn btn-primary"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
      <Dropdown id="trocar-instrutor">
        <Dropdown.Toggle bsStyle={this.state.classe_instrutor}>
          <i className="fa fa-fw fa-user"></i> {this.state.instrutor_txt}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <MenuItem eventKey={this.state.troca_index} onSelect={this.trocar_instrucao}>{this.state.troca}</MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    </ButtonToolbar>
  </form>
</div>
    );
  }
}

export default StaffsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsEditTab.js